<template>
  <v-list-tile avatar @click="reportDialog = true">
    <v-list-tile-avatar>
      <v-icon :class="[report.iconColor]">{{ report.icon }}</v-icon>
    </v-list-tile-avatar>

    <v-list-tile-content>
      <v-list-tile-title>{{ report.title }}</v-list-tile-title>
      <v-list-tile-sub-title>{{ report.subtitle }}</v-list-tile-sub-title>
    </v-list-tile-content>

    <v-list-tile-action>
      <v-btn icon ripple>
        <v-icon color="grey lighten-1">info</v-icon>
      </v-btn>
    </v-list-tile-action>

    <v-dialog v-model="reportDialog" max-width="700px" lazy>
      <v-card style="overflow: hidden;">
        <v-form @submit.prevent="runReport()" ref="reportForm">
          <v-container grid-list-xl>
            <v-layout row wrap>
              <transition-group name="field-list" tag="layout-no-padding">
                <v-flex xs12 sm7 md8 class="field-list-item" key="1">
                  <div>
                    <div class="headline">Report Options</div>
                    <div class="grey--text subheading">{{ report.title }}</div>
                  </div>
                </v-flex>
                <v-flex xs12 sm5 md4 class="flex-container-end field-list-item" key="2">
                  <v-switch
                    class="mt-0 flex-container-end"
                    label="Use Billing Period"
                    :color="primaryNeutral"
                    v-model="useBillingPeriod"
                  ></v-switch>
                </v-flex>
                <v-flex xs12 sm6 v-if="!useBillingPeriod" class="field-list-item" key="3">
                  <v-menu
                    full-width
                    offset-y
                    :close-on-content-click="false"
                    v-model="dateRangeMenu"
                    bottom
                  >
                    <v-text-field
                      slot="activator"
                      label="Date Range"
                      :value="$vuetify.breakpoint.smAndUp ? 
                                        makeLongDate(dates[0]) + ' - ' + makeLongDate(dates[1]) : 
                                        makeShortDate(dates[0]) + ' - ' + makeShortDate(dates[1])"
                      :color="primaryNeutral"
                      readonly
                    ></v-text-field>
                    <v-card>
                      <v-card-text>
                        <v-date-range v-model="dates" :options="dateRangeOptions"></v-date-range>
                      </v-card-text>
                    </v-card>
                  </v-menu>
                </v-flex>
                <v-flex xs12 sm6 v-if="!!useBillingPeriod" class="field-list-item" key="4">
                  <v-autocomplete
                    label="Billing Period"
                    :color="primaryNeutral"
                    :items="allBillingPeriods"
                    v-model="billingPeriod"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs12 sm6 class="field-list-item" key="5">
                  <v-autocomplete
                    label="Project"
                    :color="primaryNeutral"
                    :items="projects"
                    item-text="name"
                    item-value="id"
                    v-model="projectId"
                  ></v-autocomplete>
                </v-flex>
                <v-flex
                  xs12
                  sm6
                  class="vertical-center-container field-list-item"
                  style="display: flex !important;"
                  key="6"
                >
                  <v-switch
                    class="mt-0"
                    label="Summarise report data?"
                    :color="primaryNeutral"
                    v-model="summarise"
                  ></v-switch>
                </v-flex>
                <v-flex xs12 sm6 v-if="!!summarise" class="data-list-item" key="7">
                  <v-autocomplete
                    autofocus
                    label="Summarise By"
                    :color="primaryNeutral"
                    :items="rctiGroups"
                    item-text="item"
                    item-value="value"
                    v-model="groupBy"
                    clearable
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs12 sm6 v-else class="field-list-item" key="8">
                  <div style="height: 68px;"></div>
                </v-flex>
              </transition-group>
            </v-layout>
          </v-container>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn :color="primaryGrey" flat @click="reportDialog = false">Cancel</v-btn>
            <v-btn :color="primaryGreen" type="submit" flat>Run Report</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
    <!-- <v-dialog v-model="reportDisplayDialog" max-width="100%" lazy>
            <v-card>
                <v-container>
                        <v-layout row wrap>
                            <v-flex xs12 class="headline">
                                {{ report.title }}
                            </v-flex>
                            <v-flex>
                                <v-data-table v-if="!!reportDisplayDialog"
                                :items="reportData" 
                                :headers="newHeaders"
                                :rows-per-page-items="pageOptions"
                                :loading="loading"
                                disable-initial-sort
                                >   
                                    <template slot="no-data">
                                        <div class="text-xs-center grey--text subheading">
                                            No data for the selected criteria.
                                        </div>                      
                                    </template>
                                    <template slot="items" slot-scope="props">
                                        <report-row :report="props.item" :value="props.selected" :headers="newHeaders" :key="props.item.id"></report-row>     
                                    </template>
                                </v-data-table>                                
                            </v-flex>
                        </v-layout>
                </v-container>
            </v-card>
    </v-dialog>-->
  </v-list-tile>
</template>

<script>
import { addDays } from 'date-fns'
import ReportService from '@/services/requests/reportService'
import FormatDates from '@/services/mixins/formatDates'
import VDateRange from '@/components/ui/vDateRange'
import BillingPeriods from '@/services/mixins/billingPeriods'
import Store from '@/store/computed/storeHelpers'
import getProjects from '@/services/mixins/getMasterFiles/getProjects'
import HeaderFilters from '@/services/mixins/headerFilters'
import ReportRow from '@/components/reports/reportRow'

export default {
  mixins: [FormatDates, BillingPeriods, getProjects],
  data() {
    return {
      pageOptions: [
        10,
        20,
        { text: '$vuetify.dataIterator.rowsPerPageAll', value: -1 },
      ],
      loading: false,
      siteId: '',
      spoilId: '',
      tipId: '',
      vehicleTypeId: '',
      summarise: false,
      reportData: '',
      groupBy: '',
      rctiGroups: [
        {
          item: 'Site',
          value: 'siteId',
        },
        {
          item: 'Sub-contractor',
          value: 'contractorId',
        },
        {
          item: 'Driver',
          value: 'driverId',
        },
        {
          item: 'Vehicle',
          value: 'vehicleId',
        },
        {
          item: 'Spoil',
          value: 'spoilId',
        },
        {
          item: 'Tip',
          value: 'tipId',
        },
      ],
      allocationGroups: [],
      reportDialog: false,
      reportDisplayDialog: false,
      useBillingPeriod: false,
      dateRangeMenu: false,
      headers: [],
      newHeaders: [],
      dates: [
        this.makeComputerDate(addDays(new Date(), -15)), //start date. YYYY-MM-DD
        this.makeComputerDate(new Date()), // end date. YYYY-MM-DD
      ],
      now: new Date(),
    }
  },
  methods: {
    runReport() {
      this.loading = true
      this.report.reportOptions = {
        useBillingPeriod: this.useBillingPeriod,
        billingPeriod: this.billingPeriod,
        dates: this.dates,
        projectId: this.projectId,
        summarise: this.summarise,
        groupBy: this.groupBy,
      }
      var report = JSON.stringify(this.report)
      this.$router.push({ name: 'showReport', query: { report: report } })
      // ReportService.getReportData(this.report).then(result => {
      //     this.reportDialog = false;
      //     this.reportDisplayDialog = true;
      //     ////console.log(result.data.result);
      //     var tableDef = []
      //     this.reportData = result.data.result;
      //     var reportKeys = Object.keys(this.reportData[0])
      //     reportKeys.forEach( (key,i) => {
      //         //console.log(i);
      //         //console.log(key);
      //         key = {
      //             type: "text",
      //             text: key,
      //             align: "right",
      //             value: key,
      //         }
      //         this.newHeaders.push(key);
      //         //console.log(key);
      //     })
      //     //console.log(this.newHeaders);

      //     // this.headers = [
      //     //     {
      //     //         text: "ID",
      //     //         align: "left",
      //     //         value: "id",
      //     //         type: "text",
      //     //     },
      //     //     {
      //     //         text: "Date",
      //     //         align: "left",
      //     //         value: "date",
      //     //         type: "text",
      //     //     },
      //     //     {
      //     //         text: "SiteId",
      //     //         align: "left",
      //     //         value: "siteId",
      //     //         type: "text",
      //     //     },
      //     // ]
      //     // this.headers = Object.keys(this.reportData[0])
      //     // this.headers.forEach((header, i) =>{
      //     //     this.newHeaders[i].type = "text";
      //     //     this.newHeaders[i].text = header;
      //     //     this.newHeaders[i].align = "left";
      //     //     this.newHeaders[i].value = header;
      //     // })
      //     this.loading = false;

      // }).catch(err => {
      //     this.snackError();
      //     console.log(err);
      //     this.loading = false;
      // })
    },
  },
  computed: {
    billingPeriod: Store.getSet({ store: 'shared', prop: 'billingPeriod' }),
    projectId: Store.getSet({ store: 'shared', prop: 'projectId' }),
    dateRangeOptions() {
      return {
        presets: [
          {
            label: 'Today',
            range: [
              this.makeComputerDate(this.now), //start date. YYYY-MM-DD
              this.makeComputerDate(this.now), // end date. YYYY-MM-DD
            ],
          },
          {
            label: 'Month to Date',
            range: [
              this.makeComputerDate(addDays(this.now, -this.now.getDate() + 1)), //start date. YYYY-MM-DD
              this.makeComputerDate(this.now), // end date. YYYY-MM-DD
            ],
          },
          {
            label: 'Year to Date',
            range: [
              this.makeComputerDate(new Date(this.now.getFullYear(), 0, 1)), //start date. YYYY-MM-DD
              this.makeComputerDate(this.now), // end date. YYYY-MM-DD
            ],
          },
        ],
        format: 'DD/MM/YYYY',
      }
    },
  },
  props: {
    report: Object,
  },
  components: {
    VDateRange,
    ReportRow,
  },
}
</script>

<style>
</style>
